// src/components/Home/Section2.jsx
import React from "react";
import { motion } from "framer-motion";
import Person from "../../assets/img/person-placeholder.png";
import Person2 from "../../assets/img/person-placeholder-2.png";
import Person3 from "../../assets/img/person-placeholder-3.png";
import Person4 from "../../assets/img/person-placeholder-4.png";


const team = [
  { id: 1, name: "Martín Hails", role: "Gerente", photo: Person },
  { id: 2, name: "Roberto Piccon", role: "Jefe de Ingeniería", photo: Person2 },
  { id: 3, name: "Diego Gauna", role: "Jefe de Compras, Logística y Calidad", photo: Person3 },
  { id: 4, name: "Walter Muñoz", role: "Jefe de Producción", photo: Person4 },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const stagger = { show: { transition: { staggerChildren: 0.08 } } };

const Section2 = () => {
  return (
    <section id="nosotros" className="w-full flex items-center justify-center">
      <div className="w-full max-w-[1200px] px-6 py-12 sm:py-16 mx-auto">
        {/* Header */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="mb-8 sm:mb-10"
        >
          <h3 className="text-[32px] sm:text-[42px] text-white font-inversionzUnboxed tracking-wide">
            NOSOTROS
          </h3>

          {/* Línea completa + barra verde superpuesta (como el mock) */}
          <div className="relative mt-4">
            {/* <span className="block h-px w-full bg-white/30" /> */}
            <span className="h-[1px] block rounded-sm flex-1 bg-white " />

            <span className="absolute -left-1 -top-[3px] h-[6px] w-24 bg-[#21C0A8] rounded-sm" />
          </div>
        </motion.div>

        {/* Intro en itálica */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="text-white/95 text-base sm:text-xl font-inter italic mb-6"
        >
          RTAG no es solo un nombre, es una historia.
        </motion.p>

        {/* Cuerpo */}
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className=" space-y-5 text-gray-200/90 text-md sm:text-lg leading-relaxed font-inter"
        >
          <motion.p variants={fadeUp}>
            Nace de la unión de Río Tercero (RT) y Alta Gracia (AG), las ciudades
            que vieron crecer a cuatro amigos y hoy como socios, con una misma
            visión: <span className="text-[#21C0A8] font-semibold italic">dar soluciones integrales a la industria</span>.
          </motion.p>

          <motion.p variants={fadeUp}>
            Nacimos con la convicción de que la industria necesita más que proveedores:
            necesita socios cercanos, comprometidos y atentos, que entiendan cada
            necesidad como propia. <br/> <br/>
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="text-md  mt p-1 sm:text-lg leading-relaxed font-inter text-white bg-[#254E42] inline box-decoration-clone"
            >
            Nos involucramos antes, durante y después de cada proyecto. Aportamos soluciones,
            asesoramiento y respaldo de la gran industria, sin perder la calidez del trato personal.
            </motion.p>
        </motion.div>

        {/* Equipo */}
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-10 sm:mt-14 grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-10"
        >
          {team.map((m, i) => (
            <motion.div
              key={m.id}
              variants={fadeUp}
              transition={{ duration: 0.5, delay: 0.05 * i }}
              className="flex flex-col items-center text-center"
              whileHover={{ y: -4 }}
            >
              <div className="rounded-full overflow-hidden ring-1 ring-white/15">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="w-28 h-28 sm:w-36 sm:h-36 object-cover grayscale hover:grayscale-0 transition duration-300"
                />
              </div>
              <div className="mt-3">
                <div className="text-white text-sm sm:text-base font-bai">{m.name}</div>
                <div className="text-white text-xs sm:text-sm font-bai italic font-semibold">
                  {m.role}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Section2;